import { PascalCaseToCamelCase } from '@approvalmax/types';
import { objectHelpers } from '@approvalmax/utils';
import { backend, domain } from 'modules/data';

import { parseQBooksTaxCode } from './QBooksTaxCode';

export function parseQBooksAccount(
    value: backend.IntegrationsQBooksAccount | PascalCaseToCamelCase<backend.IntegrationsQBooksAccount>,
    textWithCurrency?: boolean
): domain.QBooksAccount {
    return {
        id: objectHelpers.keyOf(value, 'id'),
        text: `${objectHelpers.keyOf(value, 'name')}${textWithCurrency && objectHelpers.keyOf(value, 'currencyCode') ? ` (${objectHelpers.keyOf(value, 'currencyCode')})` : ''}`,
        code: objectHelpers.keyOf(value, 'code'),
        taxCode: objectHelpers.keyOf(value, 'taxCode')
            ? parseQBooksTaxCode(objectHelpers.keyOf(value, 'taxCode'))
            : undefined,
        type: objectHelpers.keyOf(value, 'type') as domain.QBooksAccountType,
        classification: objectHelpers.keyOf(value, 'classification') as domain.QBooksAccountType,
        currency: objectHelpers.keyOf(value, 'currencyCode')
            ? { id: objectHelpers.keyOf(value, 'currencyCode'), text: objectHelpers.keyOf(value, 'currencyCode') }
            : undefined,
        currencyCode: objectHelpers.keyOf(value, 'currencyCode'),
        fullyQualifiedName: objectHelpers.keyOf(value, 'fullyQualifiedName'),
        parentId: objectHelpers.keyOf(value, 'parentId'),
    };
}
